
<h1 mat-dialog-title>
    <ng-container *ngIf="isToSelfAssessment && !isChangeBack">
        {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.TO_SELF_ASSESSMENT_TITLE' | translate }}
    </ng-container>

    <ng-container *ngIf="isToLeaderAssessment && !isChangeBack">
        {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.TO_LEADER_ASSESSMENT_TITLE' | translate }}
    </ng-container>

    <ng-container *ngIf="isToFinished && !isChangeBack">
        {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.TO_FINISHED_TITLE' | translate }}
    </ng-container>

    <ng-container *ngIf="isChangeBack">
        {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.CHANGE_BACK_TITLE' | translate }}
    </ng-container>
</h1>
<div mat-dialog-content>
    <dynamic-text [content]="contentUrl" [useCard]="false"></dynamic-text>
</div>
<div mat-dialog-actions class="flex-h flex-end">
    <button mat-flat-button color="primary" (click)="ok()">
        <ng-container *ngIf="isToSelfAssessment && !isChangeBack">
            {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.TO_SELF_ASSESSMENT_BUTTON' | translate }}
        </ng-container>

        <ng-container *ngIf="isToLeaderAssessment && !isChangeBack">
            {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.TO_LEADER_ASSESSMENT_BUTTON' | translate }}
        </ng-container>

        <ng-container *ngIf="isToFinished && !isChangeBack">
            {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.TO_FINISHED_BUTTON' | translate }}
        </ng-container>

        <ng-container *ngIf="isChangeBack">
            {{ 'GOAL_PERIOD_STATE_CHANGE_DIALOG.CHANGE_BACK_BUTTON' | translate }}
        </ng-container>
    </button>
    <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
</div>
